const upgradePersonal = {
  bannerTitle: 'HitPaw Online الطبعة النهائية',
  introduct:
    'احصل على مزايا الأعضاء المميزة لأكثر من 35 ميزة في مجموعة الأدوات، بما في ذلك المحسنات والمزيلات ومترجمات الذكاء الاصطناعي ومسجلات الشاشة وما إلى ذلك، كل ذلك دفعة واحدة وبسعر مناسب.',
  Upgrade: 'ترقية',
  Tools: 'أدوات',
  MyProjects: 'مشاريعي',
  MyAccount: 'حسابي',
  Subscription: 'معلومات الاشتراك',
  LogOut: 'تسجيل خروج',
  PopularTools: 'أدوات شعبية',
  Enhance: 'تحسين',
  Remove: 'إزالة',
  Animate: 'تحريك',
  Extract: 'استخراج',
  SaveThreeDays: 'يتم تخزين المشاريع لمدة 3 أيام ، يرجى تنزيلها بعد المعالجة.',
  All: 'الجميع',
  Video: 'فيديو',
  Image: 'صورة',
  Audio: 'صوت',
  minutesAgo: 'قبل عدة دقائق',
  hoursAgo: 'قبل عدة ساعات',
  daysAgo: 'قبل عدة أيام',
  Modified: 'معدل',
  Order: 'لفرز',
  EarliestToLatest: 'أقرب إلى الأحدث',
  LatestToEarliest: 'الأحدث إلى أقرب',
  NoProject: 'لا مشروع حتى الآن. ابدأ سريعا مع',
  OnlineTools: 'أدوات اون لاين',
  AIVideoEnhancer: 'محسن الفيديو بالاذكاء الاصطناعي',
  Enhancer4K:
    'تحسين جودة الفيديو اون لاين حتى 4K بنقرة واحدة عبر الذكاء الاصطناعى ',
  AIPhotoEnhancer: 'محسن الصور بالاذكاء الاصطناعي',
  AIEnhancerImage:
    'تحسين جودة الصور بالذكاء الاصطناعي اون لاين دون فقدان الجودة حتى 8x ',
  View: 'عرض',
  Download: 'تحميل',
  MultipleSelect: 'حدد متعددة',
  Delete: 'حذف',
  SubscriptionHistory: 'تاريخ الاشتراك',
  NoValidSubscription: 'لا اشتراك صالح.',
  veContent: 'تحسين الفيديو حتى 4K أون لاين بالذكاء الاصطناعي بنقرة واحدة',
  peContent: 'تعمل AI على تحسين الصور بدون فقدان حتى 8X عبر الإنترنت',
  rmvContent:
    'قم بإزالة العلامات المائية والشعارات وأي شيء آخر غير مرغوبة من فيديوهاتك',
  rmttContent: 'بنقرة واحدة لتحميل فيديو تيك توك بدون علامة مائية',
  dynamicContent: 'حرك صورتك عبر الإنترنت',
  rmbgContent: 'إزالة الخلفية من الصورة',
  youMayNeed: 'قد تحتاج',
  new: 'جديد',
  rather: 'أفضل أن أدفع السعر الكامل 4.49 دولار أسبوعيا',
  loginYourAccount: 'قم بتسجيل الدخول إلى حساب HitPaw الخاص بك',
  signUpYourAccount: 'قم بالتسجيل في حساب HitPaw الخاص بك',

  HitPawWatermark: 'Watermark Remover',
  HitPawTiktokWatermark: 'TikTok Watermark Remover',
  HitPawRemoveBg: 'Background Remover',
  dynamicTitle: 'HitPaw Online Animate Old Photos',
};
export default upgradePersonal;
